import axios from 'axios';
import { CATALOG_BASE_URL } from '../constants';

export interface CatalogTool {
  id: string;
  name: string;
  tag: string;
  emoji: string;
  description: string;
  mission_id: string | null;
}

export interface CatalogSection {
  id: string;
  name: string;
  icon: string;
  lede: string;
  items: CatalogTool[];
}

export interface VaultFile {
  name: string;
  bytes: number;
}

/** A department and the tools it grants; only sent to users who can see every tool. */
export interface CatalogDepartment {
  id: number;
  name: string;
  tool_ids: string[];
}

export async function fetchCatalog(): Promise<{ sections: CatalogSection[]; departments: CatalogDepartment[] }> {
  const response = await axios.get<{ sections: CatalogSection[]; departments?: CatalogDepartment[] }>(
    `${CATALOG_BASE_URL}/catalog`,
  );
  return { sections: response.data.sections, departments: response.data.departments ?? [] };
}

export async function fetchVaultFiles(): Promise<VaultFile[]> {
  const response = await axios.get<{ files: VaultFile[] }>(`${CATALOG_BASE_URL}/vault/files`);
  return response.data.files;
}

export function vaultDownloadUrl(filename: string, asText = false): string {
  return `${CATALOG_BASE_URL}/vault/files/${encodeURIComponent(filename)}${asText ? '?format=txt' : ''}`;
}
